import React from 'react'

export default function Disclaimer() {
  return (
    <>
        <section className="counter-section-03 py-0 mt-1" style={{fontSize:'14px' , color:'black'}}>
            <div className="container" > 
                <div className="section-reservation-form section_padding">
                    <div class="row p-btm">
                        <div className="container">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                
                                <div className="swin-sc swin-sc-title style-2">
                                    <h3 className="title swin-sc-title"><span>Disclaimer</span></h3>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>
                <div>
                    <ul className="list ">
                        <li>
                            <i class="" aria-hidden="true"></i>
                                The pictures used in this webpage are for representation purpose only.
                        </li>
                        <li>
                            <i class="" aria-hidden="true"></i> 
                            An expert third party supplier has been engaged to co﻿nduct periodic Hygiene Inspections and Food Sample Collection.
                        </li>
                        <li>
                            <i class="" aria-hidden="true"></i> 
                            An allergen-free meal requires an extremely controlled environment which may not be available while cooking a large number of meals. 
    Although utmost care is taken in all areas of food production, the products prepared in our kitchen may have come into contact with common allergens. 
    Employees with food allergies are advised to use their discretion while consuming food prepared in the in-house kitchens. 
    If your allergic reactions are severe, it is advised to consume home-cooked food only.
                        </li> 
                        <li>
                            <i class="" aria-hidden="true"></i> 
                            Orders once placed cannot be cancelled.
                        </li>
                        <li>
                            <i class="" aria-hidden="true"></i> 
                            Please contact your Cafe Manager for more details.
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    </>
  )
}
